const INIT_STATE = { data: [], error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "GET_CALENDAR_SUCCESS":
      return {
        ...state,
        data: action.payload.data, //.filter((d) => d.imagePath !== null),
        error: null,
      };
    case "GET_CALENDAR_ERROR":
      return { ...state, data: [], error: action.payload };
    default:
      return state;
  }
};
